import { Grid } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetPaymentMethod } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SavePaymentMethod } from '../../shared/components';


export type UpdatePaymentMethodPageProps = {};

const UpdatePaymentMethodPage: React.FC<UpdatePaymentMethodPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_formapago);
  const returnUrlPaymentMethodsPage =
    ROUTER_PATHS.administration.metodoPagoNav;
  const { id } = useParams();
  const { data, isLoading } = useGetPaymentMethod(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_formapago)
    return <Navigate to={returnUrlPaymentMethodsPage} />;

  return (
    <Grid container spacing={2} padding="24px">
      <SavePaymentMethod
        titlePage="Editar Método de Pago"
        editPaymentMethod={data.data}
      />
    </Grid>
  );
};

export default UpdatePaymentMethodPage;
